const ru = {
  description: 'Мы помогаем лучшим командам мира достичь новых высот',
};
export default ru;
